// Charm Girl Theme JavaScript

document.addEventListener('DOMContentLoaded', function() {
  
  // Scroll-triggered animations
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, observerOptions);

  document.querySelectorAll('.animate-on-scroll').forEach(el => {
    observer.observe(el);
  });

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href !== '#') {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  });

  // Newsletter form
  const newsletterForms = document.querySelectorAll('.newsletter-form');
  newsletterForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      const btn = this.querySelector('button');
      const originalText = btn.textContent;
      btn.textContent = 'Subscribing...';
      
      // Form will submit normally, but we show feedback
      setTimeout(() => {
        btn.textContent = 'Subscribed!';
        setTimeout(() => {
          btn.textContent = originalText;
        }, 2000);
      }, 1000);
    });
  });

});
